import _ from "lodash"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"

import propertyService from "data/property"

const get = () => {
  const property = propertyService.current()
  const current = _.isNil(property) ? undefined : ( property.assetid || null )
  return current
}

const stream = new BehaviorSubject<number|null|undefined>(get())

propertyService.stream().subscribe(() => {
  const current = get()
  const assetid = stream.getValue()
  if (current === undefined) return
  if (current === assetid) return
  stream.next(current)
})

const propertyAssetService = {
  stream: () => stream.asObservable(),
  value: () => stream.getValue(),
}

export default propertyAssetService

